// extracted by mini-css-extract-plugin
export default {"root":"Shipping_root__14EBf","padded":"Shipping_padded__2WRa7","button":"Shipping_button__2NNH2","title":"Shipping_title__rdqlV","copy":"Shipping_copy__hEYfa"};